<template>
<v-container class="pa-5">
      <v-row no-gutters justify="center">
   
       <v-form
              style="margin-top: 8%; width: 370px;"
                ref="form"
                v-model="valid"
                lazy-validation
              >
            <v-card  class="pa-2" flat>
              
              <v-card-text>
                  <p class="text-center text-primary">Reset Password </p>
                  
                   <v-text-field
                        v-model="password"
                        :rules="nameRules"
                        label="Enter new password"
                        required
                         type="password"
                        dense
                        outlined
                      ></v-text-field>

                      <v-text-field
                        v-model="repassword"
                        type="password"
                        :rules="matchRules"
                        label="Confirm password"
                        required
                        dense
                        outlined
                        @change="validate()"
                         @keyup="validate()"
                      ></v-text-field>
                    
                      <v-btn
                        v-if="found"
                        color="primary"
                        block
                        :loading="loading"
                        rounded
                        dense
                        @click="submitForm()"
                      >
                       Reset Password
                      </v-btn>
                      Please check you emai
                    <v-alert
                    dense
                    text
                    type="success"
                    >
                    Please check you email <strong>{{email}}</strong> for your new password!  
                    </v-alert>
              </v-card-text>
            </v-card>
          </v-form>
   </v-row>
</v-container>
</template>
<script>

import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      code:"",
      alert: false,
      valid: true,
      found: false,
      loading: false,
      repassword: '',
      password:'',
      hash_data:'',
      nameRules: [
        v => !!v || 'Enter new password'
      ]
    }),
    mounted(){
      this.PING()
    },
    created() {
      console.log(decodeURI(this.$route.params.link))
    },
    computed:{
      HASHDATA() {
        if(this.found) {
           return this.GEN_HASH_VALUE()
        }
          return ''
      },
      matchRules() {
          return [
            this.password == this.repassword || 'Password not matched!'
          ]
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
     check_email(){
       this.$http.post("user/check_email", {email: this.email}).then(response => {
             this.GET_RESPONSE(response)
             response.data.status?this.found=true:this.found=false
              }).catch(e => {
              console.log(e.data)
          })
     },
      validate () {
        if (this.$refs.form.validate()) {
         //   this.SendLink()
        }
      },
      submitForm() {
        if (this.$refs.form.validate()) {
          this.resetPass()
        }
      },
      resetPass() {
         this.$http.post("user/reset_password", {email: this.email}).then(response => {
              if(response.data.status) {
                  this.alert = true
              }
              }).catch(e => {
              console.log(e.data)
          })
      }
    },
  }
</script>